// extracted by mini-css-extract-plugin
export default {"top_logo":"index_top_logo_eP6m2"};